import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (window.Sentry) {
      window.Sentry.captureException(error, { extra: errorInfo });
    }
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "2rem",
            textAlign: "center",
            color: "#fff",
            backgroundColor: "#1a1a2e",
          }}
        >
          <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
            Something went wrong
          </h1>
          <p style={{ color: "#aab7c4", maxWidth: "500px", marginBottom: "2rem" }}>
            We're sorry for the inconvenience. Please try refreshing the page.
            If the problem persists, contact us at{" "}
            <a href="mailto:support@tederlive.com" style={{ color: "#e94560" }}>
              support@tederlive.com
            </a>
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              backgroundColor: "#e94560",
              color: "#fff",
              border: "none",
              padding: "12px 32px",
              borderRadius: "4px",
              fontSize: "1rem",
              cursor: "pointer",
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
